import { render, staticRenderFns } from "./CustomerActions.vue?vue&type=template&id=0553599e"
import script from "./CustomerActions.vue?vue&type=script&lang=ts"
export * from "./CustomerActions.vue?vue&type=script&lang=ts"
import style0 from "./CustomerActions.vue?vue&type=style&index=0&id=0553599e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports